// Import React Library
import React, { useState, useEffect } from 'react';

// Import Images
import logoPreHouse from '../assets/images/logo-pre-house-2.png'

// Import Firebase 
import { signOut , onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/firebase.config';

// Import Components
import LogOutConfirmation from './LogOutConfirmation';
import NavbarMobileProducts from './NavbarMobileProducts';

// Import Icons
import LogoutIcon from '@mui/icons-material/Logout';

// Import Link react-router
import { Link } from 'react-router-dom';

// Navbar Component
const NavbarProducts = ({status , isDashboardNav}) => {

    // Handle responsive navbar
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Clean the event when unmount component
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const [user, setUser] = useState(null);

    // Verify if the user is loggued
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });

        return () => unsubscribe();
    }, []);

    const logOutButton = () =>{
        setShowLogOutModal(true);
    }

    // LogOut Firebase Method
    const handleLogout = async () => {
        try {
          await signOut(auth);
        } catch (error) {
          console.error('Error al cerrar sesión:', error);
        }
    };

    // Handle confirmation logout message
    const [showLogOutModal, setShowLogOutModal] = useState(false);

    return (
        <>
            {windowWidth < 1492 ? (
               <NavbarMobileProducts  status={status}/>
            ) : (
                <navbar className={isDashboardNav && 'dashboard-nav'}>
                    <Link to='/'>
                        <img src={logoPreHouse} alt='Logo PreHouse'/>
                    </Link>

                    {
                        isDashboardNav ? 
                        <ul>
                            {user && <p onClick={() => logOutButton()}>Cerrar Sesion  <LogoutIcon className='general-icon'/></p> }
                        </ul> :

                        <ul>
                            <Link to='/'>
                                <li className='text-gray-800'>Inicio</li>
                            </Link>
                            { status ? <li className='contact-link bg-gray-800 hover:bg-white'><a href='#contact-form'>CONTACTO</a></li> : ''}
                        </ul>
                    }

                    {
                        showLogOutModal && (<LogOutConfirmation setShowLogOutModal={setShowLogOutModal} handleLogout={handleLogout}/>)
                    }
                </navbar>
            )}
        </>
    );
};

// Export Navbar Component
export default NavbarProducts;